var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ricerca col-24 no-padding"},[_c('ricerca-panel',{attrs:{"filtri":_vm.filtriRicerca},on:{"closeRicerca":_vm.closeRicerca,"changeValueOrClick":_vm.changeValueOrClick,"cerca":_vm.cerca}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e00c835","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccessoStabilimenti/GestioneAppalti/AssociaDipendenti/Ricerca.vue
// module id = null
// module chunks = 